module.exports = __webpack_public_path__ + "img/MyAgenda.7eb2aaa3.svg";